function Footer({ hideAds }) {
  return (
    <div>
      {!hideAds && (
        <div className="container bagboy-wrapper">
          <a
            href="https://dynamicbrands.sjv.io/WygD5O"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/bagboy.png"
              className="center-block w-100"
              alt="BagBoy affiliate"
            />
          </a>
        </div>
      )}
      <div className="footer">
        <div className="copy">
          <div className="spacer"></div>
          Copyright &copy;{' '}
          <a
            href="https://www.codeunlimited.se"
            rel="noreferrer"
            target="_blank"
          >
            CodeUnlimited
          </a>
          <br></br>
          <a href="/privacy">Privacy Policy</a>
        </div>
        <div className="adbottom content text-center" />
      </div>
    </div>
  )
}

export default Footer
